import React from "react";

import Styles from "./controls.module.scss";

export const Input = (props) => {
    return (
        <input className={Styles.input} {...props} />
    );
}

export const Label = (props) => {
    return (
        <label className={Styles.label} {...props}>
            {props.children}
        </label>
    );
}

export const Button = (props) => {
    return (
        <button className={Styles.button} data-type={props.type} {...props}>
            {props.children}
        </button>
    )
}


export default {
    Input,
    Label,
    Button,
}



// WEBPACK FOOTER //
// ./src/components/controls/controls.js